export default "__VITE_ASSET__D41h9szt__"